export default "__VITE_ASSET__BfFAiNZB__";